import styled from 'styled-components';
import { darkgrey, white } from 'styles/Colors';

export const StepperButtonsOuter = styled.div`
  display: none;
  position: absolute;
  top: -115px;
  margin-left: -7px;
  padding-bottom: 10px;
  filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.08));
  &.always-visible {
    display: block;
  }
`;

export const StepperButtons = styled.div`
  background-color: ${white};
  padding: 4px 9px 14px 9px;
  clip-path: polygon(0% 0%, 100% 0%, 100% 90%, 60% 90%, 50% 100%, 40% 90%, 0 90%);

  svg {
    width: 40px;
    height: 40px;
    path {
      fill: ${white};
    }
    &.arrow-up {
      transform: rotate(180deg);
    }
  }
`;

export const StepperOval = styled.div`
  width: 40px;
  height: 40px;
  background-color: ${darkgrey};
  border-radius: 40px;
  -webkit-touch-callout: none; /* iOS Safari */
  -webkit-user-select: none; /* Safari */
  -khtml-user-select: none; /* Konqueror HTML */
  -moz-user-select: none; /* Firefox */
  -ms-user-select: none; /* Internet Explorer/Edge */
  user-select: none; /* Non-prefixed version, currently
                                  supported by Chrome and Opera */
  margin-bottom: 5px;
  margin-top: 5px;
  cursor: pointer;
`;

export const NumberStepperWrapper = styled.div`
  &:hover {
    ${StepperButtonsOuter} {
      display: block;
    }
  }
`;
